//@ts-check
import React, { Component } from 'react';
import AppStore from "Stores/AppStore";
import UsersStore from 'Stores/usersStore';
import 'Styles/usersView/removeUserModal.scss';

/**
 * @typedef {object} props
 * @property {WebUser} user
 * @property {boolean} physically
 * @extends {Component<props>}
 */
export default class RemoveUserModal extends Component {

    /** @param {props} props */
    constructor(props) {
        super(props);
    }

    render() {
        let userState = this.props.user.state;

        return (
            <div>
                {this.props.physically === true
                    ? `Вы собираетесь физически удалить пользователя ${this.props.user.userName}. Это приведет к безвозвратному удалению информации о его устройствах и профиля с настройками${userState.blockedReasons.meetingDisable ? "" : " в модулях «Документооборот» и «Совещания»"}. Записи, связанные с действиями пользователя, сохранятся в разделе "Протоколирование".`
                    : `Вы собираетесь удалить пользователя ${this.props.user.userName}. Это безвозвратно удалит все его ${AppStore.isMeeting ? "совещания " : "документы"} и файлы.`
                }
                <br />
                Удалить пользователя?
            </div>
        );
    }
}